import { Button, InputGroup } from "@blueprintjs/core";
import React, { useState } from "react";
import { AppToaster } from "./Toaster";

function SendFiles({ urlDownload }) {
  const [isCopy, setIsCopy] = useState(false);

  function copy(text) {
    navigator.clipboard.writeText(text);

    setIsCopy(true);

    AppToaster.show({
      message: "Link copy with success!",
      intent: "success",
    });
  }

  function cutString(str, n) {
    return str.length > n ? str.slice(0, n - 1) + "..." : str;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        height: "90vh",
        alignItems: "center",
      }}
    >
      <InputGroup
        id="inputUrl"
        fill={true}
        value={cutString(urlDownload, 140)}
        large={true}
        readOnly
        onClick={() => copy(urlDownload)}
      />
      <Button
        icon="clipboard"
        onClick={() => copy(urlDownload)}
        large={true}
        disabled={isCopy}
        intent={isCopy ? "success" : "primary"}
      >
        COPY LINK
      </Button>
    </div>
  );
}

export default SendFiles;
